export const SHIPPING_COST_INFORMATION_MODAL = 'shipping-cost-information-modal'
